export const saveFacets = async (body, country, id) => {
  const [match, csrf] = document.cookie.match(/csrf=([^;]*)/) || []; // eslint-disable-line no-unused-vars

  const SAVE_SEARCH_API_ENDPOINT = '/api/jobs/savedsearch';

  const url = id
    ? `${SAVE_SEARCH_API_ENDPOINT}/${id}?siteCountry=${country}`
    : `${SAVE_SEARCH_API_ENDPOINT}?siteCountry=${country}`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'x-csrf-token': csrf,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body), // body data type must match "Content-Type" header
    });

    const responseData = await response.json();

    if (!response.ok) {
      if (response.status === 409) {
        return { status: 'duplicate' };
      }

      throw response;
    }

    return {
      status: 'success',
      id: responseData.id,
    };
  } catch (error) {
    return { status: 'error' };
  }
};
